import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import {
  NotificationTypeEnum,
  useNotification,
} from '@prismamedia/one-components';
import { FC } from 'react';

interface PublicationStatusDialogProps {
  url: string;
  onClose: () => void;
}

export const PublicationStatusDialog: FC<PublicationStatusDialogProps> = ({
  url,
  onClose,
}) => {
  const { pushNotification } = useNotification();

  return (
    <>
      <DialogTitle>Article en cours de publication</DialogTitle>
      <DialogContent sx={{ display: 'flex', alignItems: 'baseline' }}>
        <p>Veuillez patienter, l'article est en cours de publication</p>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            navigator.clipboard.writeText(url);
            pushNotification({
              type: NotificationTypeEnum.success,
              message: 'URL copiée dans le presse-papier',
            });
          }}
        >
          Copier URL
        </Button>
        <Button variant="contained" onClick={onClose}>
          Fermer
        </Button>
      </DialogActions>
    </>
  );
};
